// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bIyr","title":"styles_title__3uLlr"};